import { ApiClient, ApiClientConfig } from "../../../api-client";
import { LogMachineLearningQuizEventContract, DynamicInputFromContract } from "@yujacorp/verity-api-contract";
import { withDefaultErrorHandler } from "../../../errors";

export class MachineLearningLoggerClient extends ApiClient {
	constructor(config: ApiClientConfig) {
		super(config, {});
	}

	logMachineLearningQuizEvent = withDefaultErrorHandler(async (dynamicInput: DynamicInputFromContract<typeof LogMachineLearningQuizEventContract>) => {
		const response = await LogMachineLearningQuizEventContract.fetch(
			`${this.config.verityOrigin}/api/verity`,
			{
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				pathParams: dynamicInput.pathParams,
				body: dynamicInput.body,
			},
			this.fetch.bind(this)
		)
		return response.ok;
	})
}
